import createItem from './createItem';
import updateItem from './updateItem';

export default (filterData, values) => (dispatch) => {
    const newValues = {
        political_division: values.city,
        wind_speed: values.wind_speed,
    };

    if (values.id) dispatch(updateItem(filterData, newValues, values.id));
    else dispatch(createItem(filterData, newValues));
};
